import styled from "styled-components";
import { GridColDef, GridFilterModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { theme } from "../../../helpers/theme";
import { GetAllUsersPayload } from "../../../services/users/get-all/types";
import { getAllUsers } from "../../../services/users/get-all";
import { StyledTable } from "../../../components/table/styled-table";
import { StyledDialog } from "../../../components/dialog/dialog";
import { deleteUser } from "../../../services/users/delete";
import { toast, ToastOptions } from "react-toastify";
import { userChangePasswordByOperator } from "../../../services/users/change-password-by-operator";
import { StyledButton } from "../../../components/Button/button";

const OperatorUsers = () => {
  const navigate = useNavigate();

  const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState(false);
  const [rowId, setRowId] = useState<string>("");
  const [usersPage, setUsersPage] = useState(0);
  const [usersFilters, setusersFilters] = useState<GridFilterModel>();

  const handleUsersPageChange = (params:any) => {
    setUsersPage(params);
  };

  const handleUsersFilterChange = (params:any, event?:any) => {
    const newFilters = params;
    setusersFilters(newFilters);
  };

  useEffect(() => {
    // Load state from session storage
    const savedPage = sessionStorage.getItem('users-page');
    if (savedPage !== null && savedPage !== undefined) {
      setUsersPage(parseInt(savedPage));
    }
    const savedFilters = sessionStorage.getItem('users-filters');
    if (savedFilters !== null && savedFilters !== undefined) {
      try {
        setusersFilters(JSON.parse(savedFilters));
      } catch (e) {
        console.error('Error parsing saved filters:', e);
      }
    }
  }, []);

  useEffect(() => {
    // Save state to session storage
    if (usersPage !== 0 && usersPage !== undefined) {
      sessionStorage.setItem('users-page', usersPage.toString());
    }
    if (usersFilters !== undefined) {
      sessionStorage.setItem('users-filters', JSON.stringify(usersFilters));
    }
  }, [usersPage, usersFilters]);



  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  useEffect(() => {
  }, [openDeleteUserDialog]);

  const GetAllUsers = useQuery(["AllUsers"], () => getAllUsers(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setUsers(data.data.payload.uzytkownicy);
    },
  });

  const DeleteUser = useMutation(deleteUser, {
    onSuccess: () => {
      GetAllUsers.refetch()
      toast.success("Usunięto pomyślnie!", { toastId: "DeletedSuccessfully", ...settings });
    },
  });

  const changeUserPassword = useMutation(userChangePasswordByOperator, {
    onSuccess: () => {
      toast.success("Wysłano maila do zmiany hasła!", { toastId: "ChangedPasswordSuccessfully", ...settings });
    },
  });

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 450,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
            }}
            onClick={() => {
              return navigate(`/operator/users/edit/login/${params.row.id}`, { state: { login: params.row.login } });
            }}
          >
            Edytuj login
          </Button>
          <Button
            variant="contained"
            style={{
              marginLeft: "10px",
              backgroundColor: theme.colors.blue01_active,
            }}
            onClick={() => {
              if (params.row.typ === "Operator") {
                users.forEach((user) => {
                  if (user.id_uzytkownik === params.row.id) {
                    return navigate(`/operator/users/edit/operator/data/${user.dane_operator.id_operator}`, { state: { imie: user.dane_operator.imie, nazwisko: user.dane_operator.nazwisko, email: params.row.email, telefon: params.row.telefon, aktywny: user.dane_operator.aktywny, aktywny_data_do: user.aktywny_do } });
                  }}
                )
              } else if (params.row.typ === "Podwykonawca") {
                users.forEach((user) => {
                  if (user.id_uzytkownik === params.row.id) {
                    return navigate(`/operator/users/edit/subcontractor/data/${user.dane_wykonawca.id_wykonawca}`);
                  }}
                )
              } else if (params.row.typ === "Klient") {
                users.forEach((user) => {
                  if (user.id_uzytkownik === params.row.id) {
                    return navigate(`/operator/clients/edit/${user.dane_klient.id_klient}`);
                  }}
                )
              }
            }}
          >
            Edytuj dane
          </Button>

          <Button
            variant="contained"
            style={{
              marginLeft: "10px",
              backgroundColor: "red",
            }}
            onClick={() => {
              setOpenDeleteUserDialog(true);
              setRowId(params.row.id);
            }}
          >
            Usuń
          </Button>
          

          <Button
            variant="contained"
            style={{
              marginLeft: "10px",
              backgroundColor: "green",
            }}
            onClick={() => {
              changeUserPassword.mutate({ id_uzytkownika: params.row.id});
            }}
          >
            Zmień hasło
          </Button>
        </>
      ),
    },
    { field: "login", headerName: "Login", width: 250 },
    { field: "aktywny_od", headerName: "Aktywny od", width: 150 },
    { field: "aktywny_do", headerName: "Aktywny do", width: 150 },
    { field: "typ", headerName: "Typ", width: 150 },
    // { field: "id", headerName: "Nr", width: 100 },
    { field: "nazwa", headerName: "Nazwa", width: 200 },
    { field: "email", headerName: "E-mail", width: 250 },
    { field: "telefon", headerName: "Telefon", width: 150 },
  ];

  const [users, setUsers] = useState<GetAllUsersPayload[]>([]);

  const body = {
    paginacja: null,
  };

  const getTypeFromEnum = (type: number) => {
    switch (type) {
      case 0:
        return "Operator";
      case 1:
        return "Podwykonawca";
      case 2:
        return "Klient";
    }
  };

  const distinguishUser = (user: GetAllUsersPayload, dataType: number) => {
    switch (user.typ_uzytkownika) {
      case 0:
        switch (dataType) {
          case 0:
            return user.dane_operator.imie + " " + user.dane_operator.nazwisko;
          case 1:
            return user.dane_operator.email;
          case 2:
            return user.dane_operator.telefon;
        }
        break;
      case 1:
        switch (dataType) {
          case 0:
            return user.dane_wykonawca.nazwa;
          case 1:
            return user.dane_wykonawca.email;
          case 2:
            return user.dane_wykonawca.telefon;
        }
        break;
      case 2:
        switch (dataType) {
          case 0:
            return user.dane_klient.nazwa;
          case 1:
            return user.dane_klient.email;
          case 2:
            return user.dane_klient.telefon;
        }
        break;
    }
  };

  const dateFormating = (date: Date) => {
    if (date !== null) {
      const dateSeconds = Date.parse(date?.toString());
      const dateObject = new Date(dateSeconds);
      return dateObject.toLocaleDateString("pl-PL");
    } else {
      return "Brak";
    }
  };

  const rows = users.map((r) => ({
    id: r.id_uzytkownik,
    login: r.login,
    aktywny_od: dateFormating(r.aktywny_od),
    aktywny_do: dateFormating(r.aktywny_do),
    typ: getTypeFromEnum(r.typ_uzytkownika),
    nazwa: distinguishUser(r, 0),
    email: distinguishUser(r, 1),
    telefon: distinguishUser(r, 2),
  }));

  if (GetAllUsers.isLoading || GetAllUsers.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <UsersContainer>
      <StyledButton
        variant="contained"
        sx={{ width: "202px" }}
        onClick={() => {
          return navigate(`/operator/users/add`);
        }}
      >
        Dodaj użytkownika
      </StyledButton>
      <StyledTable
        // getRowId={(row) => row?.numer_zamowienia}
        rows={rows}
        columns={columns}
        page={usersPage}
        filterModel={usersFilters}
        onPageChange={handleUsersPageChange}
        onFilterModelChange={handleUsersFilterChange}
        // pageSize={5}
        // rowsPerPageOptions={[5]}
        // autoHeight
        autoPageSize
        // onRowClick={() => navigate(url.operatorOrdersDetails)}
      />
      
      <StyledDialog
            open={openDeleteUserDialog}
            setOpen={setOpenDeleteUserDialog}
            confirmFunction={() =>
              DeleteUser.mutate({
                id_uzytkownik: rowId
              })
            }
            dialogContent="Czy na pewno chcesz usunąć tego użytkownika?"
          />
    </UsersContainer>
  );
};

export default OperatorUsers;

const UsersContainer = styled.div`
  height: 80vh;
  width: 100% - 300px;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
